import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "submit"]

  connect() {
    this.toggle()
  }

  toggle() {
    this.submitTarget.disabled = this.selectTarget.selectedOptions.length === 0;
  }
}
